<template>
    <div>
        for deep link
    </div>
</template>

<script>
    export default {
        beforeCreate(){
            window.location = 'v4.weserve://deeplink.weserve?action=show_dialog&title=ทดสอบ&desc=มาจากdeeplink'
        }
    }
</script>

<style lang="scss" scoped>

</style>